const Translation = {
    testPrefix: '*****'
};

export default function
Translate( key, defaultValue )
{
    if( !defaultValue )
    {
        return key;
    }
    else
    {
        return  defaultValue;
    }
}


// WEBPACK FOOTER //
// ./src/Atollon/Translation.js